module.exports = __webpack_public_path__ + "img/failure.e69ee806.svg";